ACC.productDetail.searchbar = {

    bindProductDetailSearchbar: function () {
        $(".js-clearSearch").on("click", function (e) {
            e.preventDefault();

            var attributeSearchContainer = $(this).closest(".productdetail-attributesearch");
            var inputField = attributeSearchContainer.find(".js-productdetail-searchbar-input");
            var productVariantsDiv = $(".js-product-variant-div");

            attributeSearchContainer.find(".js-clearSearch").removeClass("fa icon-times").hide();
            attributeSearchContainer.find(".js-prevSearch").removeClass("fa fa-angle-up").hide();
            attributeSearchContainer.find(".js-nextSearch").removeClass("fa fa-angle-down").hide();
            attributeSearchContainer.find(".js-search-count").addClass("hide");
            clearTimeout(inputField.data('timer'));

            productVariantsDiv.removeHighlight();
            $(".js-productdetail-searchbar-input").attr("data-index", "0");

            if (inputField.val()) {
                inputField.val("");

                attributeSearchContainer.find("li").hide();
                attributeSearchContainer.find("li").fadeIn();
            }
        });
        $(".js-nextSearch").on("click", function (e) {
            e.preventDefault();

            var index = Number($(".js-productdetail-searchbar-input").attr("data-index"));
            var total = Number($(".js-productdetail-searchbar-input").attr("data-total"));

            index = index + 1;
            if (index >= total) index = 0;

            $(".js-productdetail-searchbar-input").attr("data-index", index);
            jumpToMatch();
        });
        $(".js-prevSearch").on("click", function (e) {
            e.preventDefault();

            var index = Number($(".js-productdetail-searchbar-input").attr("data-index"));
            var total = Number($(".js-productdetail-searchbar-input").attr("data-total"));

            index = index - 1;
            if (index < 0) index = total - 1;

            $(".js-productdetail-searchbar-input").attr("data-index", index);
            jumpToMatch();
        });

        function jumpToMatch() {
            $(".search-highlight").removeClass("search-highlight");

            var matches = $(".highlight").closest("li");
            var index = Number($(".js-productdetail-searchbar-input").attr("data-index"));

            $(matches[index]).find("span .highlight").addClass("search-highlight");
            if (!ACC.common.isElementInView(matches[index])) {
                matches[index].scrollIntoView({
                    block: 'center', behavior: 'smooth'
                });
            }
        }

        function updateSearchCount() {
            var inputBar = $(".js-productdetail-searchbar-input");

            var index = Number(inputBar.attr("data-index"));
            var total = Number(inputBar.attr("data-total"));

            if (total > 0)
            $(".js-search-count").text((index+1) + "/" + total);
            else
            $(".js-search-count").text((index+0) + "/" + total);
        }

        function highlightAttributes(enteredText) {
            var productVariantsDiv = $(".js-product-variant-div");
            var inputBar = $(".js-productdetail-searchbar-input");

            // Removing highlight MUST be called before search. Otherwise it will have sideeffects on search!
            productVariantsDiv.removeHighlight();
            
            var searchResult = productVariantsDiv.find(".dim-label span:containsCaseInsensitive('" + enteredText + "')");
            
            inputBar.attr("data-total", searchResult.length);
            if (enteredText) {
                searchResult.closest("li").highlight(enteredText);
            }

            inputBar.attr("data-index", "0");

            jumpToMatch();
        }

        $(".js-productdetail-searchbar-input").on("input", function (e) {
            e.preventDefault();

            var inputField = $(this);
            var attributeSearchContainer = inputField.closest(".productdetail-attributesearch");

            if (inputField.val()) {
                ACC.product.hidePerfectMatch();

                attributeSearchContainer.find(".js-clearSearch").addClass("fa icon-times").show();
                attributeSearchContainer.find(".js-prevSearch").addClass("fa fa-angle-up").show();
                attributeSearchContainer.find(".js-nextSearch").addClass("fa fa-angle-down").show();
                attributeSearchContainer.find(".js-search-count").removeClass("hide");
            } else {
                attributeSearchContainer.find(".js-clearSearch").removeClass("fa icon-times").hide();
                attributeSearchContainer.find(".js-prevSearch").removeClass("fa fa-angle-up").hide();
                attributeSearchContainer.find(".js-nextSearch").removeClass("fa fa-angle-down").hide();
                attributeSearchContainer.find(".js-search-count").addClass("hide");
            }
            clearTimeout(inputField.data('timer'));
            var wait = setTimeout(function () {
                highlightAttributes(inputField.val());
                
                updateSearchCount();
            }, 450);
            inputField.data('timer', wait);
        });
    }
};

$(document).ready(function initializePdp() {
    if ($(".page-productDetails").length) {
        with (ACC.productDetail.searchbar) {
            bindProductDetailSearchbar();

            $(window).scroll(function (e) {
                var $el = $('.productdetail-attributesearch');
                var isPositionFixed = ($el.css('position') == 'fixed');
                if ($(this).scrollTop() > 300 && !isPositionFixed) {
                    $el.css({'position': 'fixed', 'top': '0px'});
                    $el.css({'width': '400px'});
                }
                if ($(this).scrollTop() < 300 && isPositionFixed) {
                    $el.css({'position': 'static', 'top': '0px'});
                    $el.css({'width': '100%'});
                }
            });
        }

    }
});
